import type { ButtonProps, ButtonType } from "@repo/skapa";
import { ResponsiveButton } from "@repo/ui";
import { hasItems } from "@repo/utils";
import type { SVGProps } from "react";

export interface Action {
  id: string;
  text?: string;
  icon: (prefix?: string) => SVGProps<SVGElement>[];
  iconPosition?: ButtonProps["iconPosition"];
  showIcon?: boolean;
  onClick: ButtonProps["onClick"];
  href?: string;
  newWindow?: boolean;
  type?: ButtonType;
  iconOnly?: boolean;
  title?: string;
  disabled?: boolean;
  loading?: boolean;
}

interface ActionTitleActionsProps {
  actions: Action[];
}

export const ActionTitleActions = ({ actions }: ActionTitleActionsProps) => {
  return (
    <>
      {hasItems(actions) &&
        actions.map((a) => (
          <ResponsiveButton
            key={`action-button-${a.id}`}
            breakpoint="xl"
            text={a.text}
            icon={a.icon}
            iconOnly={a.iconOnly}
            onClick={a.onClick}
            href={a.href}
            showIcon={a.showIcon ?? true}
            size="small"
            type={a.type ?? "secondary"}
            title={a.title}
          />
        ))}
    </>
  );
};
